import React from 'react';
import { Calendar, Timer, UsersThree, Rows } from '@phosphor-icons/react';
import Typhography from '../../../shared/Typhography/Typhography';
import styles from './StatsKpiRow.module.scss';
import type { IStatsAggregates } from '../../../models/trainingStatistics';

/**
 * Sezione 1 — KPI Overview cards.
 * Spec: LEOPART_ProgrammazioneCampo_Spec_v1.1.1.md righe 2777-2786.
 */
interface StatsKpiRowProps {
  aggregates?: IStatsAggregates;
}

const StatsKpiRow: React.FC<StatsKpiRowProps> = ({ aggregates }) => {
  const totalMinutes = aggregates?.totalMinutes ?? 0;
  const totalSessions = aggregates?.totalSessions ?? 0;
  const totalBlocks = aggregates?.totalBlocks ?? 0;
  const hours = Math.floor(totalMinutes / 60);
  const minutes = totalMinutes % 60;

  const kpis = [
    {
      label: 'Sessioni totali',
      value: totalSessions.toString(),
      sub: '',
      Icon: Calendar,
    },
    {
      label: 'Minuti totali',
      value: totalMinutes.toLocaleString('it-IT'),
      sub: `(${hours}h ${minutes}m)`,
      Icon: Timer,
    },
    {
      label: 'Blocchi totali',
      value: totalBlocks.toString(),
      sub: '',
      Icon: Rows,
    },
  ];

  return (
    <div className={styles.row}>
      {kpis.map(({ label, value, sub, Icon }) => (
        <div key={label} className={styles.card}>
          <div className={styles.iconWrap}>
            <Icon size={20} weight="fill" />
          </div>
          <div className={styles.cardBody}>
            <Typhography size="bold-32" className={styles.value}>
              {value}
            </Typhography>
            {sub && <Typhography size="regular-12" className={styles.sub}>{sub}</Typhography>}
            <Typhography size="regular-12" className={styles.label}>{label}</Typhography>
          </div>
        </div>
      ))}
    </div>
  );
};

export default StatsKpiRow;
